import { useCurrentStateAndParams } from "@uirouter/react";
import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";

import { keywordGroupsTransforms } from "app/services/keyword-groups";
// eslint-disable-next-line max-len
import { useToggleQueryBarForKeywordGroups } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/useToggleQueryBarForKeywordGroups";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ETabs } from "./constants";
import YoutubeKeywordGeneratorChart from "./YoutubeKeywordGeneratorChart";
import { YoutubeKeywordGeneratorTables } from "./YoutubeKeywordGeneratorTables";

export const YoutubeKeywordGeneratorResultsPage = () => {
    const { params } = useCurrentStateAndParams();
    useToggleQueryBarForKeywordGroups();

    const isKeywordGroup = keywordGroupsTransforms.isKeywordGroup(params.keyword);

    const onTabSelect = (index: ETabs): void => {
        proNavigator.updateParams({ tab: camelCase(ETabs[index]), sort: undefined, asc: undefined });
    };

    return (
        <>
            {!isKeywordGroup ? <YoutubeKeywordGeneratorChart /> : null}
            <YoutubeKeywordGeneratorTables
                {...params}
                selectedTab={ETabs[upperFirst(params.tab)]}
                onTabSelect={onTabSelect}
            ></YoutubeKeywordGeneratorTables>
        </>
    );
};
